"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDOPS_APP_NAME_OOI_SUFFIX = '-ooi';
exports.FEDOPS_APP_NAME_SSR_SUFFIX = '-ssr';
//# sourceMappingURL=fedops.const.js.map